import * as Yup from 'yup'

export const userNoteSchema = Yup.object().shape({
  note: Yup.string().trim().max(255, 'Note should not exceed 255 characters'),
})
